export default {
  didi: {
    title: 'DiDi Food',
    ico: 'https://img0.didiglobal.com/static/gstar/img/44jNTMtjaN1545446385429.ico',
    DEFAULT_LOGO: 'https://img0.didiglobal.com/static/gstar/img/Oe6JhHfrUX1610970919105.png',
  },
  99: {
    title: '99 Food',
    ico: 'https://img0.didiglobal.com/static/gstar/img/zaKalGdBvJ1744205176096.png',
    DEFAULT_LOGO: 'https://img0.didiglobal.com/static/gstar/img/ml5jGsVn1o1610970901079.png',
  },
}
